import { enableProdMode } from '@angular/core';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { sentryInit } from '@usheru-hff/sdk/sentry';

import { currentGitVersion } from './app/version';

if (environment.mode === 'prod') {
  enableProdMode();
}

sentryInit(
  environment,
  'https://6d1e9f5eeca1d6e5129179fd218bb7c4@o4508858213859328.ingest.de.sentry.io/4508879381528656',
  currentGitVersion
);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
